import { Injectable } from '@angular/core'
import { QuoteData } from '../models/quote.model';
import { Action } from '@ngrx/store';

export const UPDATE_QUOTE_DATA = '[QUOTE_DATA] UPDATE';
export class UpdateQuoteData implements Action {
    readonly type = UPDATE_QUOTE_DATA;

    constructor(public payload: QuoteData) { }
}

export type Actions = UpdateQuoteData;
